import { ChevronRight, X } from "react-feather";
import { Link } from "react-router-dom";
import { Href } from "../../../Constants/Constants";
import { AppListData } from "../../../Data/Messenger/Messenger";
import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";
import { closeAppSidebar, setAppSidebarActiveTab } from "../../../ReduxToolkit/Reducers/Messenger/AppSidebar";
import { dynamicImage, Image } from "../../../Utils";
import SvgIcon from "../../CommonComponents/SvgIcon";
import { CloseAppSidebar } from "../../../ReduxToolkit/Reducers/Messenger/Messenger";

const AppList= () => {
  const { appSidebarActiveTab } = useAppSelector((state) => state.appSidebar);
  const dispatch = useAppDispatch();

  return (
    <div className="app-list">
      <ul className="app-list-ul custom-scroll">
        <li className="title apps-toggle" onClick={() => dispatch(CloseAppSidebar())}>
          <ChevronRight />
        </li>
        <li className="right-sidebar-profile">
          <div className="profile">
            <Image className="bg-img rouded15" src={dynamicImage("avtar/6.jpg")} alt="Avatar" />
          </div>
        </li>
        {AppListData.map((item, index) => (
          <li key={index}>
            <Link className={`icon-btn btn-outline-primary btn-sm button-effect ${appSidebarActiveTab === item.type ? "active" : ""}`} to={Href} onClick={() => dispatch(setAppSidebarActiveTab(item.type))}>
              <SvgIcon className="stroke-primary" iconId={`stroke-${item.icon}`} />
            </Link>
          </li>
        ))}
        <li className="close-app">
          <Link className="icon-btn btn-danger" to={Href} onClick={() => dispatch(closeAppSidebar())}><X /></Link>
        </li>
      </ul>
    </div>
  );
};

export default AppList;
